var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-content" }, [
    _c("div", { staticClass: "home-gallery-wrapper" }, [
      _c("div", { ref: "swiper", staticClass: "swiper" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.$store.state.homePhotos, function (photo) {
            return _c("div", { staticClass: "swiper-slide" }, [
              _c("img", {
                attrs: { src: photo },
                on: {
                  load: function ($event) {
                    _vm.imagesLoaded++
                  },
                },
              }),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isDevice,
              expression: "!isDevice",
            },
          ],
          staticClass: "home-gallery-navigation",
        },
        [
          _c("button", {
            staticClass: "navigation-button-prev",
            attrs: { type: "button" },
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "navigation-button-next",
            attrs: { type: "button" },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }